import { styled } from "@mui/material/styles"
import LoadingButton, { LoadingButtonProps } from "@mui/lab/LoadingButton"
import { MEDIUM, SMALL } from "constants/index"
import CircularProgress from "components/atoms/CircularProgress"

interface StyledCTAProps {
  variantColor?: "primaryDark" | "default";
}

export default function CTA(props: LoadingButtonProps & StyledCTAProps) {
  return (
    <StyledCTA
      {...props}
      loadingIndicator={<CircularProgress/>}
    />
  )
}

const StyledCTA = styled(LoadingButton, {
  shouldForwardProp: (prop) => prop !== "variantColor"
})<LoadingButtonProps & { variantColor?: string }>(({ theme, variantColor, variant, size, color }) => ({
  ...((variantColor === "primaryDark") && variant === "contained" && {
    backgroundColor: theme.palette.primary["10"],
    color: theme.palette.gray[2],
    "&:hover": {
      backgroundColor: theme.palette.primary["10"]
    }
  }),

  ...((variantColor === "primaryDark") && variant === "outlined" && {
    backgroundColor: "transparent",
    border: `1px solid ${theme.palette.primary["10"]}`,
    color: theme.palette.primary["10"],
    "&:hover": {
      backgroundColor: theme.palette.primary["1"]
    }
  }),

  ...((variantColor === "primaryDark") && variant === "text" && {
    backgroundColor: "transparent",
    color: theme.palette.primary["10"],
    "&:hover": {
      backgroundColor: theme.palette.primary["1"]
    }
  }),
  minWidth: 88,
  height: size === SMALL ? "30px" : (size === MEDIUM ? "40px" : "52px"),
  fontSize: variant === "text" ? "14px" : (size === SMALL ? "1.1rem" : (size === MEDIUM ? "1.3rem" : "16px")),
  fontWeight: 400,
  borderRadius: 128,
  width: "100%",
  padding: "10px 6px",
  flexDirection: "row-reverse",
  boxShadow: "none !important",

  "& .MuiLoadingButton-loadingIndicator": {
    position: "relative",
    right: 0,
    left: 0,
    transform: "translate(50%)"
  },

  "& span": {
    marginRight: "8px"
  }
}))
